import React from 'react'

const Gaukomaya = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका शब्द र अर्थबिच जोडा मिलाउनुहोस् ।</h5>
        <p>(क) कोला = खेतको गरो</p>
        <p>(ख) आर्द्र = नरम ; रसिलो</p>
        <p>(ग) क्रीतदास = पैसा दिएर दास बनाएको</p>
        <p>(घ) ओरहा = पूर्ण नपाकेको मकै, गहुँलाई पोलेर तयार पारेको खानेकुरा</p>
        <p>(ङ) ठालु = गाउँबस्तीमा आफ्नो हैकम जमाउने मान्छे</p>
      </div>
      <div>
        <h5>२. दिइएका अर्थ दिने शब्द पाठबाट खोजेर लेख्नुहोस् ।</h5>
        <p>(क) स्वतन्त्र = उन्मुक्त</p>
        <p>(ख) कपडाको भकुन्डो = गिर</p>
        <p>(ग) अड्काउ = अल्झो</p>
        <p>(घ) भिन्न हुनाको अभाव = पृथक्ताबोध</p>
        <p>(ङ) अर्काको काम गरिदिएबापत पाइने परिश्रमिक = वनी</p>
        <p>(च) इज्जत = अभिमान</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्दहरुको अर्थ खुल्ने गरी वाक्यमा प्रयोग गर्नुहोस् ।</h5>
        <strong>(क) नौटङ्की</strong>
        <p>साना कुरामा रुनु उनका लागि मात्र नौटङ्की हो।</p>
        <strong>(ख) रिहर्सल</strong>
        <p>नाटक सुरु हुनु अघि कलाकारहरूले राम्रोसँग रिहर्सल गरे।</p>
        <strong>(ग) हुटहुटी</strong>
        <p>उनी विदेश जान नपाउँदा मनमा हुटहुटी भइरह्यो।</p>
        <strong>(घ) आली</strong>
        <p>हाम्रो खेतको छेउमा पानी बग्ने सानो आली छ।</p>
        <strong>(ङ) अन्तराल</strong>
        <p>नाटकको पहिलो भागपछि १० मिनेटको अन्तराल दिइयो।</p>
        <strong>(च) कृपापात्र</strong>
        <p>उनी सदैव गुरूको कृपापात्र बनेका छन्।</p>
        <strong>(छ) नासो</strong>
        <p>यो पुरानो घडी हजुरबुबाको नासो हो, जसलाई म संजालेर राख्छु।</p>
        <strong>(ज) रण</strong>
        <p>वीर गोर्खालीहरू रणमै मर्न तयार हुन्थे।</p>
        <strong>(झ) मानसपट</strong>
        <p>विद्यालयको त्यो घटना मेरो मानसपटमा अझै ताजा छ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका टुक्काहरुको प्रयोग गरी एउटा अनुच्छेद तयार पार्नुहोस् ।</h5>
        <p>परिछन, बुधना, वखतवहादुर र कृष्ण मिल्ने गाउँका साथी हुन्‌ । परिछन अर्काको घरमा हली बसेको छ। भोलि यस कार्यको बिँडो परिछनको छोरोले थाम्छ । परिछनले आफ्नो पाखुरी वजारेकै भरमा मालिकलाई खुसी बनाएको छ । आफ्ना गरिब साथीहरूको परिश्रम मेहेनत देखेर कृ्‌ष्णजी लाजले पानी पानी भएको थियो । जमिनदारहरूले गरिव जनतालाई केही क्रण दिएर उनीहरूलाई जीवनभर आफ्नो बसमा पार्थे । अर्काको घरमा बसेर काम गर्ने भए पनि परिछन, बुधना, रामदरस, कृष्ण साथीहरूसँग हातेमालो गर्थे ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. कक्षामा छलफल गरेर माथिका बाहेक अरु प्रचलित दशवटा टुक्का खोजेर लेख्नुहोस् ।</h5>
        <p>नाक काट्नु , खुट्टा तान्नु , कानमा तेल हाल्नु , रातो मुख लगाउनु , कन्सिरी तात्नु , श्रीगणेश गर्नु , हावा लाग्नु , सुइँको पाउनु , टाउको खानु , आलु खानु ।</p>
      </div>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. `गाउँको माया´ कथा पढी दिइएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) यस कथामा कतिओटा अनुच्छेद छन् ?</h5>
        <p>= यस कथामा १४ ओटा अनुच्छेद छन् ।</p>
        <h5>(ख) सातौं अनुच्छेदमा कतिओटा वाक्य छन् ?</h5>
        <p>= सातौं अनुच्छेदमा २ ओटा वाक्य छन् ।</p>
        <h5>(ग) कृष्णको प्रवेश कुन अनुच्छेदमा भएको छ ?</h5>
        <p>= कृष्णको प्रवेश तेस्रो अनुच्छेदमा भएको छ ।</p>
        <h5>(घ) `म´ पात्र किन गाउँ गएको हो ?</h5>
        <p>= गाउँको मायाले गर्दा म पात्रा गाउँ गएको हो ।</p>
        <h5>(ङ) कथामा आदि, मध्यम र अन्त्यका मुख्य मुख्य घटना टिपोट गर्नुहोस् ।</h5>
        <strong>आदि भाग</strong>
        <p> दुई वर्षदेखि आफ्नो गाउँ ज्ञान चाहेका कृ्‌ष्ण यसपटक गाउँ गएका छन्‌ ।</p>
        <p>गाउँको मायाले र त्यहांको वातावरणले उनलाई धेरै नै तानेको थियो ।</p>
        <p>आफ्ना धेरै साथीहरू गाउँमा गरिवीका कारण अर्काको घरमा हली वसेर जिविकोपार्जन गरिरहेका छन्‌ ।</p>
        <p>कृष्णले राम्रो पढाइका कारण उ सहर गएर पढ्न पाएको छ ।</p>
        <strong>मध्य भाग</strong>
        <p> कृष्णको घर आउँदा वाटामा आफ्नो पुरानो साथी परिछनसँग भेट हुन्छ ।</p>
        <p>परिछन गरिब भएकै कारण अर्काको घरमा काम गरेर जिविको पार्जन गर्छन्‌ ।</p>
        <p>आफूले काम गरेको पारिश्रमिक वढाउनुपन्यो भनी मालिकविर्द्ध आवाज उठाउंदा मालिकहरूले उनीहरूलाई नै फुटाएर पारिश्रमिक नवढाएकोमा अत्यन्तै दु:खी भएका छन्‌ ।</p>
        <strong>अन्त्य भाग</strong>
        <p> यसरी मालिकहरूले गरिवलाई गरेको थिचोमिचो विरुद्ध संधै लाडरहने कुरा परिल्लनले कृष्णलाई सुनाए ।</p>
        <p> यस्तो अन्याय अत्याचार सहेर पनि परिछन जस्ता मानिस त्यसको विरुद्धमा लडिरहेछन्‌ ।</p>
        <p>आफ्नो गाउँमा भएको अन्याय, अत्याचार, शोषण, गरिवीलाई समेटेर एउटा नाटक लेख्न परिछनले कृष्णलाई अनुरोध गरेका छन्‌ ।</p>
        <p> यसरी धेरैबेर आफ्नो पुरानो साथीसंग गफ गरेर कृष्ण आफ्नो घरतर्फ लागेका छन्‌ ।</p>
      </div>
      <div>
        <h5>२. गाउँको माया कथाका आधारमा दिइएका घटनाक्रमलाई क्रमबद्ध रुपमा लेख्नुहोस् ।</h5>
        <p>(ग) `म´ पात्र करिब दुई वर्षपछि आफ्नो गाउँले जीवनका अनेक घटना सम्झिदै गाउँतिर फर्किनु,</p>
        <p>(ङ) परिछनले जयरामजीकी भनी बोलाएको आवाजले `म´ पात्र झस्किनु,</p>
        <p>(छ) परिछनसँग गाउँका अनेक दुखसुखका कुराकानी गर्नु,</p>
        <p>(झ) परिछन खोला छेउको कुवामा पानी लिन जानु र `म´ पात्रले खोलाका राम्रा नराम्रा पक्षमा सोच्नु,</p>
        <p>(क) पानी लिएपछि परिछनले गाउँका ठालुका कारण गाउँमा तीन पाटी भएको कुरा सुनाउनु,</p>
        <p>(घ) तिमी गाउँमै भए ठालुहरुले यसरी सताउन नसक्ने कुरा परिछनले `म´ पात्रलाई बताउनु,</p>
        <p>(ख) `म´ पात्राले तिमीहरुकै कारणले गाउँ प्रगतिको पथमा छ भन्दै राम्रो कामको श्रेय परिछनलाई दिएर सम्मान प्रकट गर्नु,</p>
        <p>(च) महावीरजीको झन्डा मेलामा गाउँकै घटनाहरु राखेर परिछनले `म´ पात्रलाई नाटक लेख्न अनुरोध गर्नु,</p>
        <p>(ज) गाउँमा टेक्न नपाउँदै एउटा गहन जिम्मेवारी पाएको कुरा सोच्दै `म´ पात्र घरतिर लाग्नु ।</p>
      </div>
      <div>
        <h5>३. गाउँको माया काथाका संवादका क्रममा अन्य भाषाबाट आएका केही वाक्यहरु पनि छन् । छलफल गरि ती वाक्यहरुको अर्थ पत्ता लगाउनु होस् ।</h5>
        <h5>(क) “जब उतर गए रण पे तो पिछे हटना क्योँ ?”</h5>
        <p>= कुनै कामको थालनी गरिसकेपछि पूरा नगरी पछाडि हट्नु हुन्न ।</p>
        <h5>(ख) “ह गोलो , फुर्ती से चाल बढाके ।”</h5>
        <p>= श्रमरत हुदाँ फुर्तीले पाइला अगाडि बढाउनुपर्छ ।</p>
        <h5>(ग) “गाई चारवाहा टुअर-टापर, भैँस चारवाह चोर । बाकरी चारवाह छिनर-छानर, ताके चार ओर।”</h5>
        <p>= गाई भैंसी वा बाख्रा चराउँदा नै किन नहोस् सधै चनाखो भई चारैतिर हेर्नुपर्छ ।</p>
      </div>
      <div>
        <h5>४. “जमाना थियो….उनीहरुसँग मिसिन्थेँ “काथांश पढी सोधिएका प्रश्नहरुको सङ्क्षिप्त उत्तर दिनुहोस् ।</h5>
        <h5>(क) `म´ पात्रलाई पढाउनुपर्छ भनी उत्साह भर्ने को थिए ?</h5>
        <p>= `म´ पात्रलाई पढाउनुपर्छ भनी उत्साह भर्ने `म´ पात्रको गाउँका छिमेकीहरु थिए ।</p>
        <h5>(ख) परिछनको नियति कसरी पुस्तान्तरण भएको हो ?</h5>
        <p>= आथिर्क अवस्था कम्जोर भएकाले परिछनको नियति पुस्तान्तरण भएको हो ।</p>
        <h5>(ग) यस अनुच्छेदमा प्रयुक्त लोकगीतको अंशले दिने विचारप्रति आफ्नो धारणा व्यक्त गर्नुहोस् ।</h5>
        <p>= यस अनुच्छेदमा शिक्षा र चेतनाको कमी भएका ग्रामीण सरल नागरिकहरु गाई, भैंसी वा बाख्रा चराउँदा जुनसुकै बेलामा पनि चनाखो भएर हेर्नुपर्ने नत्र गाई, भैंसी वा बाख्राले खेतेपातीमा क्षति पुर्याउन सक्ने भनी गोठाले जीवनको सरल ग्रामीण जीवनको सङ्केत गरेको पाइन्छ ।</p>
        <h5>(घ) `म´ पात्रले परिछन लगायतका बालदौंतरीसँग सम्बन्ध सुधार्न के के गर्यो होला ?</h5>
        <p>= `म´ पात्रले परिछन लगायतका बालदौंतरीसँग सम्बन्ध सुधार्न विद्यालय विदा परेको बेला कहिले ओराहा खाने, कहिले गिर खेल्ने, कहिले कपर्दी खेल्ने वा त्यस्तै केही निहुँ पारेर उनीहरुसँग मिसिने, खेल्ने गर्थे ।</p>
        <h5>(ङ) यस अनुच्छेदको मुख्य सन्देश के हो ?</h5>
        <p>= यस अनुच्छेदको मुख्य सन्देश आफ्ना बाल्यकालका साथीलाई कहिलै बिर्सिनु हुदैन भन्ने हो ।</p>
      </div>
      <div>
        <h5>५. दिइएको कथांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) खोलाले रुवायो भन्ने कुरा मात्र गर्दा कसरी अन्याय हुन्छ ?</h5>
        <p>= खानेपानीको आपुर्तिदेखि लिएर गाईवस्तुलाई खुवाउने र खेतीबारीम सिँचाइ गर्ने गाउँलेहरु खोलामानै निर्भर छन् । तेसैले खोलाले पुर्याउने सामान्य असरभन्दा खोलाको फाइदा नै बढी भएकाले खोलाले रुवायो भन्ने कुरा गर्दा अन्याय हुन्छ ।</p>
        <h5>(ख) `म´ पात्रका खोलासँगका बालअनुभुति कस्ता छन् ?</h5>
        <p>= खोलामा बाढी आएको बेला गाई, भैसीको पुच्छर समातेर बाढी तरेको, खोलामा उर्लेर भेलबाढी आएको बेला रमाउँदै खोलाको किनारमा बसेर बाढीको आनन्द लुटेको आदि जस्ता म पात्रका खोलासँगका बालअनुभुतिहरु अत्यन्त रमाइला एवम् अविस्मरणीय छन् ।</p>
      </div>
      <div>
        <h5>६. दिइएको कथांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) कृष्णलाई सबैले किन सम्मान गरेका हुने ?</h5>
        <p>= ‘गाउँको माया’ कथाको प्रमुख पात्र कृष्ण शिक्षित, देशप्रेमी, जन्मभूमिलाई औधी माया गर्ने व्यक्ति हो। ऊ पढेलेखेको भएता पनि उ भित्र कति पनि घमण्ड छैन। उसले सबैलाई एउटै नजरले हेर्छ। सधै सकारात्मक सोच्ने र अरूको हित मा काम गर्न तयार कृष्णलाई सबैले सम्मान गर्नुको मुख्य कारण ऊ भित्र भएको सद्गुण नै हो। गाउँलेहरुले उसलाई अभिमान र इज्जतका रुपमा हेर्छन्।</p>
        <h5>(ख) पढेलेखेका मान्छेले गाउँ छोड्यो भने गाउँमा कस्तो असर पर्छ ?</h5>
        <p>= पढेलेखेको मान्छेले गाउँ छोडे भने गाउँमा अशिक्षित धनी व्यक्ति र गाउँका ठूला व्यक्तिले एकलौटी रजाइँ गर्छन्। यस्तो रजाइँको चपेटामा गाउँ का गरिब वर्ग पर्छन्। कथाको सन्दर्भमा पनि कृष्ण एक पढेलेखेको मान्छे भएतापनि गाउँमा अनुपस्थित रहनाले समाजको गरिब वर्गलाई अगुवाई गर्ने व्यक्तिको अभाव भएको छ। यसकारण परिछन जस्ता गरिब वर्गका व्यक्ति आफ्नो साउन र गाउँका ठूला व्यक्ति दमन अत्याचार र एकलौटी रजाइँ चपेटामा परेका छन्।</p>
      </div>
      <div>
        <h5>७. व्याख्या गर्नुहोस् :</h5>
        <h5>(क) हाम्रा गाउँमा पनि साच्चैका मान्छेहरु रहेछन् जो जीवनलाई बुझ्दै छन् ।</h5>
        <p>= प्रस्तुत कथांश कक्षा ११ को अनिवार्य नेपाली पुस्तकमा समावेश ‘गाउँको माया’ भन्ने सामाजिक यथार्थवादी कथाबाट उद्धृत गरिएको हो। कथाकार इस्मालीद्वारा लिखित यस कथामा गाउँको यथार्थ, परम्परा, र विकासको सम्भावना विषयवस्तु बनेको छ। दुई वर्ष विदेश बसेर फर्किएका मुख्य पात्र कृष्णले गाउँमा देखिएका सकारात्मक परिवर्तन र चेतनाको विकासप्रति आश्चर्य र खुशी व्यक्त गरेका छन्।</p>
        <p>कृष्णले विदेशमा रहेर पनि गाउँको मायालाई मनमा बसाइराखेका छन्। पहिले परम्परागत सोचमा सीमित गाउँलेहरू अब विकासप्रति जागरूक हुन थालेका छन्। गाउँका मानिसहरूमा परिवर्तन आएको, उनीहरू जीवनलाई बुझ्न थालेका छन् भन्ने कुरा कृष्णको चिठीबाट प्रकट हुन्छ। उनी विकासमा गाउँको सम्भावना देख्छन् र गाउँमै केही गर्न सकिन्छ भन्ने आत्मविश्वास पलाएको देखिन्छ। गाउँमा भएका सानातिना राम्रा कार्यहरूले पनि मानिसहरूको जीवन सार्थक हुने कुरामा उनी विश्वस्त छन्।</p>
        <p>यस कथांशमा जन्मभूमिप्रतिको गहिरो प्रेम, समाज रूपान्तरणको चेतना, र गाउँमै बसेर परिवर्तन सम्भव छ भन्ने सन्देश व्यक्त भएको छ। युवाहरूले विदेशिनुको सट्टा गाउँमै रहेर शिक्षाको सहायताले सामाजिक विकासमा योगदान दिनुपर्ने सन्देश कथाले दिन खोजेको छ। परम्परागत जीवनशैलीलाई आत्मसात गर्दै आधुनिकताको समायोजन गर्नु नै कथा लेखकको मूल उद्देश्य देखिन्छ।</p>
      </div>
      <div>
        <h5>(ख) तिम्रो पाखुरीले खोलाको धारलाई फर्काउँछ भने गाउँको इज्जत माथी नउठाउला त ?</h5>
        <p>= प्रस्तुत कथांश कक्षा ११ को अनिवार्य नेपाली पाठ्यपुस्तकमा समावेश सामाजिक यथार्थवादी कथा ‘गाउँको माया’ बाट साभार गरिएको हो। समाजका सूक्ष्म र गम्भीर विषयहरूलाई केन्द्रमा राखेर लेखिएको यस कथाका लेखक इस्माली हुन्। यो भनाइ मुख्य पात्र कृष्णले सहायक पात्र परिछनको पीडाप्रति प्रतिक्रिया जनाउने क्रममा बोलेका हुन्। परिछनले गाउँमा साहुहरूले गरिबमाथि अत्याचार गरेको गुनासो गर्दा कृष्णले उसको सामर्थ्य र श्रमको कदर गर्दै यो प्रेरणादायी कुरा भनेका हुन्।</p>
        <p>कथामा परिछन जस्ता किसान, मजदुर र श्रमिक वर्गका पात्रहरू गरिब भए पनि साहुहरूसँगभन्दा धेरै इमानदार, पौरखी र शक्तिशाली छन्। गाउँमा हुने खेतीपाती, उत्पादन र कामधन्दा सबै उनीहरूको पाखुरीको बलमा चल्दछ। उनीहरूले प्रयोग गर्ने खुर्पा, हरिया, कोदालो, र मिहिनेतले गाउँ बाँचेको छ। कथामा देखिएको वर्गीय अन्यायको सन्दर्भमा कृष्णले भन्न खोजेका छन् कि यदि परिछन जस्ता श्रमिकहरू संगठित भए, भने उनीहरूले गाउँको इज्जत, अस्तित्व र पहिचान माथि उठाउन सक्छन्।</p>
        <p>यस कथांशमा कृष्णद्वारा श्रमजीवी वर्गको शक्ति र योगदानप्रतिको सम्मान प्रकट भएको छ। परम्परागत रूपमा हेपिएका तर समाजका वास्तविक आधार हुने श्रमिकहरूको भूमिका महत्वपूर्ण छ भन्ने सन्देश दिइएको छ। गाउँको वास्तविक इज्जत र पहिचान श्रम गर्ने हातहरूमा छ भन्ने कुरा मार्मिक ढंगले प्रस्तुत गरिएको छ। कृषकहरूको श्रमले जसरी खोला मोड्न सकिन्छ, त्यही श्रमले समाजमा परिवर्तन ल्याउन पनि सकिन्छ भन्ने चेतनाले कथालाई प्रेरणादायी बनाएको छ।</p>
      </div>
      <div>
        <h5>८. समीक्षात्मक उत्तर दिनुहोस् :</h5>
        <h5>(क) `गाउँको माया´ कथामा कस्तो समाजको चित्रण गरिएको छ ?</h5>
        <p>= सामाजिक यथार्थवादी दृष्टिकोणबाट इस्मालीद्वारा लिखित कथा ‘गाउँको माया’ मा नेपाली ग्रामीण समाजको यथार्थपरक चित्रण गरिएको छ। यस कथामा लेखकले विशेषगरी वर्गीय विभाजन र त्यसबाट उत्पन्न सामाजिक द्वन्द्वलाई मूल विषयवस्तु बनाएका छन्। समाजमा रहेका दुई वर्ग: सम्पन्न वर्ग (साहु, जमिनदार) र विपन्न वर्ग (परिछन जस्ता किसान, मजदुर)—बीचको सम्बन्ध कथा मार्फत प्रस्तुत गरिएको छ।</p>
        <p>कथामा सम्पन्न वर्गले विपन्न वर्गलाई शोषण गर्ने, दबाउने र अपमान गर्ने गरेको देखिन्छ। विपन्न वर्ग भने आफ्नो हकहितका लागि संगठित हुँदै सामाजिक न्यायको माग गर्दै अगाडि बढिरहेको छ। विपन्न वर्गका पात्रहरू जस्तै परिछनहरूले आफ्नो जीवनस्तर सुधार्न मेहनत गरिरहेका छन्। तर, सम्पन्न वर्ग यो परिवर्तन स्वीकार्न चाहँदैन र ‘फुटाऊ र शासन गर’ भन्ने रणनीतिमा लागेको देखिन्छ।</p>
        <p>यसरी, ‘गाउँको माया’ कथामा वर्गीय द्वन्द्व, सामाजिक अन्याय, र श्रमजीवी वर्गको संघर्ष स्पष्ट रूपमा चित्रण गरिएको छ। श्रमिक वर्गको सामर्थ्य, चेतना, र उनीहरूको योगदानप्रति सकारात्मक दृष्टिकोण प्रकट भएको छ। कथाले समाजमा विद्यमान वर्गीय असमानता विरुद्ध आवाज उठाउनुपर्छ भन्ने सन्देश पनि दिन खोजेको छ।</p>
      </div>
      <div>
        <h5>(ख) गाउँको माया कथाका आधारमा दिइएको पात्रहरुको चरेचित्रण गर्नुहोस् ।</h5>
        <strong>(अ) कृष्ण :</strong>
        <p>कृष्ण स्थिर स्वभावका पात्र हुन्, जसले समाजमा भइरहेको वर्गीय अन्याय, शोषण र भेदभावको विरोध गर्छन्। उनी शोषक वर्गको अत्याचारको अन्त्य गर्नुपर्छ र विपन्न वर्गलाई स्वतन्त्रता, सम्मान र हक–अधिकार दिनुपर्छ भन्ने विचार राख्छन्। कृषक, मजदुर वर्गका पीडा र संघर्षप्रति उनी संवेदनशील छन् र परिवर्तनको पक्षमा अडिग रहन्छन्।</p>
        <strong>(ख) परिछन :</strong>
        <p>परिछनले समाजमा भइरहेको साहु, महाजन, र मालिकहरूको एकल वर्चस्व, अन्याय, शोषणको विरोध गर्छन्। उनले सहयोग र एकताले सामाजिक परिवर्तन सम्भव हुन्छ भन्ने विश्वास राख्छन्। उनको विचारमा गरिब, श्रमिक वर्गले एकजुट भएर आफ्नो हक अधिकारको लागि संघर्ष गर्नु आवश्यक छ। उनी वर्गीय मुक्ति चाहने, समनताको पक्षपाती पात्रको रूपमा चित्रित छन्।</p>
      </div>
      <div>
        <h5>९. दिइएको गद्यांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) निबन्धकारको मतका आधारमा अनाथालय भएको र नभएको समाजको अन्तर बताउनुहोस् ।</h5>
        <p>= निबन्धकारको मतका आधारमा अनाथालय भएको समाजमा दया, माया, सेवा र सहयोग भावना जाग्दछ भने अनाथालय नभएको समाजमा व्यभिचार, पाप एवं सामाजिक कुकृत्यहरु भएका हुन्छन् ।</p>
        <h5>(ख) हामी अनाथ, गरिब र बिरामीलाई के कसरी सहयोग गर्न सक्छौ ?</h5>
        <p>= हामी अनाथ, गरिब र बिमारीलाई आफुले सकेको चन्दा दिएर लगायत विभिन्न खानेकुराहरु, लत्ताकपडा दिएर सहयोग गर्न सक्छौ ।</p>
        <h5>(ग) अनाथालयप्रति तपाईंको धारणा कस्तो छ ?</h5>
        <p>= अनाथ पनि यसै देशका नागरिक भएकाले राज्यले नै उनीहरुको गास, बाँस र कपासको व्यवस्थापनको लागि अनाथालयहरु खोली व्यवस्थित गर्नुपर्छ अनि हामीले पनि सक्दो सहयोग गर्नुपर्छ भन्ने मेरो धारणा छ ।</p>
        <h5>(घ) 'समाजमा बिगार्नेभन्दा सपार्ने धेरै छन् ' भन्नुको तात्पर्य के हो ?</h5>
        <p>= 'समाजमा बिगार्नेभन्दा सपार्ने धेरै छन् ' भन्नुको तात्पर्य यस समाजमा नकारात्मक सोच भएका, सामाज बिगार्ने मानिसहरुभन्दा असल, सज्जन, समाजको भलो चिताउने मानिस नै धेरै हुन्छन् हो ।</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. रेखाङ्कन गरिएका शब्द मूल वा व्युत्पन्न के हुन् , पहिचान गरेर लेख्नुहोस् ।</h5>
        <strong>(क) मूल शब्दहरु</strong>
        <p>भाइ, हामी, काम, धोखा, चार, धान, फूल</p>
        <br/>
        <strong>(ख) व्युत्पन्न शब्दहरु</strong>
        <p>उथलपुथल(उथल + उथल)</p>
        <p>रोपाइँ( रोप् + आइँ)</p>
        <p>राम्रै(राम्रो + ऐ)</p>
        <p>अगुवा(अगि + उवा)</p>
        <p>धनी (धन + ई)</p>
        <p>केरकार(केर + कार)</p>
        <p>झगडाफसाद(झगडा + फसाद)</p>
        <p>एकता(एक + ता)</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएको अनुच्छेदमा मूल र व्युत्पन्न शब्द पहिचान गरी सुची बनाउनु होस् ।</h5>
        <strong>(क) मूल शब्दहरु</strong>
        <p>आठ, नौ, वर्ष, उमेर, पुर्खा, काल, पनि, सीप, आफू, गीत</p>
        <br/>
        <strong>(ख) व्युत्पन्न शब्दहरु</strong>
        <p>बालक(बाल + क),</p>
        <p>लेखपढ(लेख + पढ)</p>
        <p>बाल्यकाल(बाल्य + काल)</p>
        <p>गाउन(गाउँ + न)</p>
        <p>विद्यालय(विद्या + आलय)</p>
        <p>परिश्रम(परि+ श्रम)</p>
        <p>मिठा(मीठो+ आ)</p>
        <p>सङ्गीत(सम् + गीत)</p>
      </div>
      <hr/>
      <div>
        <h3>शब्दस्रोत</h3>
        <h5>१. दिइएको कथांशमा गाढा अक्षरमा लेखिएका शब्दहरु तत्सम, तद्भव र आगन्तुक के हुन् छुट्याउनुहोस् ।</h5>
        <strong>तत्सम शब्दहरु</strong>
        <p>पङ्क्ति, आगन्तुक, एक, शान्ति ,भङ्ग</p>
        <strong>तद्भव शब्दहरु</strong>
        <p>आँखा(अक्ष), हात(हस्त), हल्ला(कोलाहल), रिस(रोप)</p>
        <strong>आगन्तुक शब्दहरु</strong>
        <p>अखबार, लिफाफा , कागज, वावा</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरु ध्यानपुर्वक पढ्नुहोस् र तत्सम, तद्भव र आगन्तुक शब्दहरुको बेग्लाबेग्लै सुची बनाउनु होस् ।</h5>
        <strong>तत्सम शब्दहरु</strong>
        <p>पृथ्वी, अग्नि, वायु, ऋषि, ज्ञान, प्रज्ञा, ऊर्जा , छात्र</p>
        <strong>तद्भव शब्दहरु</strong>
        <p>जेठ(जेष्ठ), साउन(श्रावण), असार(अषाढ), बाटो(वत्र्म), सासू(श्वश्रू), ससुरा(श्वसुर), आगो(अग्नि)</p>
        <strong>आगन्तुक शब्दहरु</strong>
        <p>पसल, पटुवा, ढाट, कदर, ढेवा, जागिर, दिल, हाकिम, पाइप</p>
      </div>
      <hr/>
      <div>
       <h5>३. दिइएको अनुच्छेदबाट तत्सम शब्द पहिचान गरी सुची बनाउनु होस् ।</h5>
       <p>अनुभूति, नदी, हृदय, सभ्यता, हिमाल, चित्ताकर्षक, भावनात्मक, जन्मभुमि, रुप, भूमि</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएको अनुच्छेद पढी तद्भव र आगन्तुक शब्द छुट्याएर लेख्नुहोस् ।</h5>
        <strong>तद्भव शब्दहरु</strong>
        <p>अँध्यारो(अन्धकार), रात(रात्रि), खेत(क्षेत्र), हात(हस्त), बाटो(वत्र्म), काँध(स्कन्ध), गाउँ(ग्राम), मानिस(मानुष), सबै(सर्व)</p>
        <strong>आगन्तुक शब्दहरु</strong>
        <p>लालटिन, जर्नेल, साहेब, रेडियो, मोबाइल , लाइट, थर्मस, चिया, सिकार, भेल</p>
      </div>
      <hr/>
      <div>
        <h3>१. प्रश्नहरु</h3>
        <h5>(क) माथिको शब्दकोशका नमुना पानामा दिइएका शब्दहरुले के कस्ता अर्थ दिएका छन् लेख्नुहोस् ।</h5>
        <strong>अँगार</strong>
        <p>जलिसकेको र आगोको झिल्का देखिने कोइला; ताप दिने रातो कोइला।</p>
        <strong>अँगेठी</strong>
        <p>धातु वा माटोबाट बनाइएको सानो चुल्हो, जसमा कोइला वा काठ बालेर खाना पकाइन्छ।</p>
        <strong>अँगेर</strong>
        <p>खानाको भाँडो वा ढकनी समात्न प्रयोग गरिने कपडाको सानो टुक्रा; तातो समाउँदा हात नडढोस् भनेर प्रयोग गरिने वस्त्र।</p>
        <strong>अँजुली</strong>
        <p>दुवै हातको अँगुलीहरू मिलाएर बनाइएको खोच, जसमा पानी वा केही सानोतिनो वस्तु राख्न सकिन्छ।</p>
        <strong>अँचेला</strong>
        <p>कपडाको अगाडिको भाग, विशेषतः महिलाले पहिरिने पोशाकको अगाडिको झोलिनेजस्तो भाग; कुनै वस्तु राख्न प्रयोग गरिने कपडाको भाग।</p>
        <strong>अँचेटिनु</strong>
        <p>कुनै वस्तुलाई कपडाको छेउ वा अँचेलाले समाएर वा बेरेर राख्नु; वस्तु ढाक्नु वा छोप्नु।</p>
        <strong>अँगालो</strong>
        <p>कसैलाई काखमा हालेर समाउने कार्य; प्रेम वा आत्मीयताको संकेतस्वरूप गरिएको आलिङ्गन।</p>
        </div>
        <div>
          <h5>(ख) शब्दकोश हेरी माथिको शब्दकोशको नमुना पानामा छड्के अक्षरमा दिइएका सङ्क्षिप्त शब्दका पूरा रुप लेख्नुहोस् ।</h5>
          <p>निपा : निपात</p>
          <p>ना : नाम</p>
          <p>क. क्रि : कर्मवाच्य क्रिया</p>
          <p>वि : विशेषण</p>
          <p>टु : टुक्का</p>
          <p>स. क्रि : सकर्मक क्रिया</p>
          <p>पे.क्रि : प्रेरणार्थक क्रिया</p>
          <p>पू.स : पूर्वसर्ग</p>
        </div>
        <hr/>
        <div>
           <h5>(ग) शब्दकोश हेरी दिइएका शब्दको अर्थ लेख्नुहोस् ।</h5>
           <strong>अकेला </strong>
           <p>एक्लो, साथीसंगी वा संगीने नभएको; छुट्टिएको।</p>
           <strong>पिन्चे</strong>
           <p>फूलपाती, विवाह, आदि कार्यक्रममा प्रयोग गरिने सानो झलमल्ल झाँकी वा सजावट; सानो झण्डा वा झल्के।</p>
           <strong>एकाघर</strong>
           <p>एउटै घरमा बस्ने वा एउटै परिवारमा पर्ने व्यक्ति; सँगै घर भएका नातेदार।</p>
           <strong>जातक</strong>
           <p>बुद्धका जन्मपूर्वका जीवनकथाहरू; बुद्धले विभिन्न जन्ममा गरेका कर्मकाण्ड र कथाहरू समेटिएको ग्रन्थ।</p>
           <strong>रोहबर</strong>
           <p>दुलाहा पक्षबाट दुलही लिन जाँदा साथमा जाने मान्छे; बिहेको साक्षी वा प्रतिनिधि।</p>
           <strong>ठाँट</strong>
           <p>ठाटटप्प, धूमधाम, शानशौकत; सजावट वा देखासिकी।</p>
           <strong>घडा</strong>
           <p>माटो वा धातुबाट बनाइएको ठूलो पानी वा तरल पदार्थ राख्ने भाँडो।</p>
           <strong>चैत्य </strong>
           <p>बौद्ध धर्ममा पूजनीय स्तूप वा गुम्बा; बुद्धको अवशेष वा सम्झनामा बनाइएको पूजास्थल।</p>
           <strong>पँधेरो</strong>
           <p>पानी लिने सार्वजनिक स्थान; इनार वा मूलको वरिपरि बनाइएको पानी लिने ठाउँ।</p>
           <strong>यथार्थ</strong>
           <p>साँचो अवस्था; वास्तविकता; कल्पना वा झूट नभएको सत्य।</p>   
        </div>
        <hr/>
        <div>
          <h5>(घ) दिइएका शब्दहरुलाई शब्दकोशको क्रममा लेख्नुहोस् ।</h5>
          <p>(अ) कंश कपडा कृष्ण क्रम क्षति मस्त शारीरिक</p>
          <p>(आ) आँधी आफू इश्वर उर्लनु ऊर्जा एउटा ऐश्वर्य</p>
          <p>(इ) ज्ञान तिम्रो त्रास मानसिक मूल मृत्यु व्यवहार</p>
          <p>(ई) अँध्यारो अचानो आँधी उपकार उपहार अपेक्षा ओठशब्दभण्डार</p>
        </div>
    </div>
  )
}

export default Gaukomaya
